import axios from "axios";
import { BRANDS_URL, DEVICES_URL, DEVICE_MODELS_URL, DEVICE_OVERALL_URL, FORCE_REGISTER_URL, UPLOAD_EXCEL_URL } from "../config/urls";
import queryString from 'query-string';

export const useUploadDeviceExcel = () => {

    return async (file, model) => {

        try {
            const formData = new FormData();

            formData.append('records', file);
            formData.append('model', model);
            const res = await axios.post(UPLOAD_EXCEL_URL, formData, {
                headers: {
                    authorization: 'bearer ' + localStorage.getItem('token'),
                }
            });

            return res.data.file
        } catch (e) {
            return null
        }
    }
};


export const useGetDeviceOverallInfo = () => {

    return async () => {
        try {
            const res = await axios.get(DEVICE_OVERALL_URL, {
                headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
            });

            return res.data
        } catch (e) {
            return {}
        }
    }
};


export const useGetDeviceModels = () => {

    return async () => {
        try {
            const res = await axios.get(DEVICE_MODELS_URL, {
                headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
            });

            return res.data.models
        } catch (e) {
            return {}
        }
    }
};


export const useGetBrands = () => {

    return async () => {
        try {
            const res = await axios.get(BRANDS_URL, {
                headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
            });

            return res.data.brands
        } catch (e) {
            return {}
        }
    }
};


export const useCreateBrand = () => {

    return async (name) => {
        try {
            const res = await axios.post(BRANDS_URL, { name }, {
                headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
            });

            return res.data.tag
        } catch (e) {
            return {}
        }
    }
};


export const useCreateModel = () => {

    return async (name, ram, storage, brandTag) => {
        try {
            console.log(name, ram, storage, brandTag);
            const res = await axios.post(DEVICE_MODELS_URL, { name, ram, storage, brandTag }, {
                headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
            });

            return res.success
        } catch (e) {
            return {}
        }
    }
};


export const useGetDevicesOfPage = () => {

    return async (page, filters = {}) => {
        try {
            const query = queryString.stringify(filters)
            const res = await axios.get(`${DEVICES_URL}/${page}?${query}`, {
                headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
            });
            const devices = res.data.devices.map(d => ({ ...d, model: d.model.name, nationalId: d.customer?.nationalId, customer:d.customer?.name, phoneNumber:d.customer?.phoneNumber   }))
            return { devices, count: res.data.count }
        } catch (e) {
            return {}
        }
    }
};



export const useForceRegistery = () => {

    return async ({name, dateOfBirth, province, nationalId, imei, phoneNumber}) => {
        try {
            await axios.post(FORCE_REGISTER_URL, {
                name,
                dateOfBirth,
                province,
                nationalId,
                imei,
                phoneNumber
            }, {
                headers: {
                    Authorization: 'bearer ' + localStorage.getItem('token')
                }
            });
            return true
        } catch (e) {
            return false
        }
    }
};
